import * as z from "zod/v4";

export const triggerBackInStockNotifications = {
  name: "triggerBackInStockNotifications" as const,
  input: z.object({
    productId: z.string().describe("Shopify product ID"),
    variantId: z.string().describe("Shopify variant ID"),
    oldInventoryCount: z.number().int().describe("Previous inventory count"),
    newInventoryCount: z.number().int().min(1).describe("New inventory count"),
  }),
  output: z.object({
    notificationCount: z
      .number()
      .int()
      .describe("Number of notifications triggered"),
    flowsChecked: z
      .boolean()
      .describe("Whether flows were checked and triggered"),
  }),
};
